export const variables = {}
if (typeof wp_params !== 'undefined') {
  variables.restURL = wp_params.rest_url
  variables.restNonce = wp_params.rest_nonce
}
